import { inject, Injectable } from '@angular/core';
import { DashboardResponse } from '@com-delta-idp/mnx-oauth';
import {
  AnalyticsProfile,
  AnalyticsSiteAssets,
  ContentBodyAbodeSupportAnalytics
} from '@com-delta-idp/mnx-utils';
import { enc, SHA256 } from 'crypto-js';
import { map } from 'rxjs/operators';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';

@Injectable({
  providedIn: 'root'
})
export class ContentBodyClickEventAnalyticsUtils {
  private accountSummary = inject(AccountSummaryService);
  protected contentBodyAbodeSupportAnalytics = inject(
    ContentBodyAbodeSupportAnalytics
  );

  setHomePageLoadAssetAnalytics(
    site_assets: AnalyticsSiteAssets[],
    langCode: string,
    countryCode: string,
    durationSec: string
  ): void {
    this.accountSummary
      .getAccountSummaryDetails()
      .pipe(
        map((response: DashboardResponse) => {
          if (!response || Object.keys(response).length === 0) {
            return {
              profile: null as AnalyticsProfile | null,
              isWarmState: false
            };
          }
          this.contentBodyAbodeSupportAnalytics.setIsLoggedIn(true);
          const getValueOrEmpty = (
            value: string | undefined | null
          ): string => {
            return value === undefined || value === null ? '' : value;
          };
          const emailAddress = getValueOrEmpty(response?.primaryEmailAddress);
          const encryptedEmail = emailAddress
            ? SHA256(emailAddress).toString(enc.Base64)
            : '';
          return {
            ...response,
            profile: {
              skymiles_number: getValueOrEmpty(response?.smNumber),
              skymiles_tier: getValueOrEmpty(response?.membershipLevel),
              amex_card_type: getValueOrEmpty(response?.smeCardTypes),
              available_miles: getValueOrEmpty(response?.smBalance),
              email: emailAddress,
              email_domain: emailAddress
                ? emailAddress.split('@')[1] || ''
                : '',
              encrypted_email: encryptedEmail
            } as AnalyticsProfile
          };
        })
      )
      .subscribe(({ profile, isWarmState }) => {
        this.contentBodyAbodeSupportAnalytics.populateHomePageAssets(
          site_assets,
          isWarmState,
          profile,
          countryCode,
          langCode,
          durationSec
        );
      });
  }
}
